import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer, LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'

export default async function loader({ params }: LoaderFunctionArgs) {
  await isAppStateReady()

  useStockStore.getState().resetReviewTenderSlice()

  const { tenderId } = params
  if (!tenderId) {
    return defer({ data: Promise.resolve(false) })
  }

  const tenderPromise = useStockStore.getState().loadTenderReview(tenderId)

  return defer({
    data: Promise.all([tenderPromise])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Review Tender error: ', error)
        return false
      }),
  })
}
